import { render, staticRenderFns } from "./SubAgencyBillDetail.vue?vue&type=template&id=35e33575&scoped=true"
import script from "./SubAgencyBillDetail.vue?vue&type=script&lang=js"
export * from "./SubAgencyBillDetail.vue?vue&type=script&lang=js"
import style0 from "./SubAgencyBillDetail.vue?vue&type=style&index=0&id=35e33575&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e33575",
  null
  
)

export default component.exports